/**
 * 已知问题：
 * 1. 不支持 NaN 作为 key
 */

export default class LiteMap {

  _keys = [];
  _values = [];
  size = 0;

  constructor(kvs = []) {
    kvs.forEach(kv => {
      this._keys.push(kv[0]);
      this._values.push(kv[1]);
    });
    this.size = kvs.length;
  }

  clear() {
    this._keys = [];
    this._values = [];
    this.size = 0;
  }

  delete(key) {
    let {_keys, _values} = this;
    let i = _keys.indexOf(key);
    if (i < 0) return;
    _keys.splice(i, 1);
    _values.splice(i, 1);
    this.size--;
  }

  forEach(callback) {
    let {_keys, _values} = this;
    for (let i = 0; i < _keys.length; i++) {
      callback(_values[i], _keys[i]);
    }
  }

  get(key) {
    let {_keys, _values} = this;
    let i = _keys.indexOf(key);
    return _values[i];
  }

  has(key) {
    return Boolean(this._keys.indexOf(key) >= 0);
  }

  keys() {
    return this._keys.slice();
  }

  set(key, value) {
    let {_keys, _values} = this;
    let i = _keys.indexOf(key);
    i = i < 0 ? _keys.length : i;
    _keys[i] = key;
    _values[i] = value;
    this.size = _keys.length;
  }

  values() {
    return this._values.slice();
  }
}



// WEBPACK FOOTER //
// ../x/packages/util/src/map-lite.js